global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

$(document).ready(function() {

    const body = $('body');
    const header = $('header');
    const main = $('main');
    const headerMenuWrapper = $('.header__menu-wrapper');
    const ducaleCursor = $('.ducale-cursor');
    var mouseX;
    var mouseY;

    // Sticky scroll Header
    if ($('header.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
            onTop : function() {
                changeHeaderColor(false);
                main.removeClass('has-scroll')
            },
            onNotTop : function() {
                changeHeaderColor(true);
                main.addClass('has-scroll')
            },
        }
        var headerHeadroom  = new Headroom(headroomEl, options)
        headerHeadroom.init();
        global.headerHeadroom = headerHeadroom;
    }

    // Submenu - click into li element for open/close submenu (toggle mode)
    $('.main-menu__item--has-submenu > a, .main-menu__item--has-submenu > span').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        let mainMenuItem = $(this).parent('.main-menu__item');
        let subMenu = mainMenuItem.find('.main-menu__submenu-wrapper');
        if (subMenu.hasClass('main-menu__submenu-wrapper--open')) {
            submenuClose();
        } else {
            submenuOpen(mainMenuItem, subMenu);
        }
    })

    // Submenu - close method
    function submenuClose() {
        changeHeaderColor(false);
        submenuCloseAll();
        body.removeClass('overflow-y-hidden');
    }

    // Submenu - close all submenus opened
    function submenuCloseAll() {
        $('.main-menu__submenu-wrapper--open')
            .stop()
            .slideUp(300, function () {
                $(this).removeClass('main-menu__submenu-wrapper--open');
            })
        $('.main-menu__item--has-submenu i').removeClass('fa-minus').addClass('fa-plus');
    }

    // Submenu - open method
    function submenuOpen(mainMenuItem, subMenu) {
        submenuCloseAll();
        if (mainMenuItem.hasClass('has-works')) {
            header.removeClass('header--std').addClass('header--works');
        } else {
            header.removeClass('header--works').addClass('header--std')
        }
        subMenu.stop().slideDown(300, function () {
          $(this).addClass('main-menu__submenu-wrapper--open');
          mainMenuItem.find('i').toggleClass(['fa-plus','fa-minus']);
        })
        body.addClass('overflow-y-hidden');
    }

    // Submenu - close button
    $('.main-menu__submenu-close').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        submenuClose();
    })

    // Change Header color (set fill: on open submenu or on scroll)
    function changeHeaderColor(fill = true) {
        header.removeClass(['header--std','header--works','header--home']);
        if (fill) {
            if (header.attr('data-type') === 'header--home') {
                if (window.innerWidth <= 991 || header.hasClass('headroom--not-top')) {
                    header.addClass('header--std');
                }
            } else {
                header.addClass(header.attr('data-type'));
            }
        } else {
            if (header.attr('data-type') === 'header--home' && header.hasClass('headroom--not-top')) {
                header.addClass('header--std');
            } else {
                header.addClass(header.attr('data-type'));
            }
        }
    }

    // Burger menu
    $('.burger-menu').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!$(this).hasClass('burger-menu--open')) {
            headerMenuWrapper.addClass('header__menu-wrapper--show');
            $(this).addClass('burger-menu--open');
            changeHeaderColor(true);
            body.addClass('no-scroll-y');
        } else {
            $(this).removeClass('burger-menu--open');
            headerMenuWrapper.removeClass('header__menu-wrapper--show');
            changeHeaderColor(false);
            body.removeClass('no-scroll-y');
            body.removeClass('overflow-y-hidden');
        }
    });

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 400) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    // CURSOR
    // Mouse Move event on window, set global offsets
    window.addEventListener('mousemove', function (e) {
        mouseX = e.clientX;
        mouseY = e.clientY;
    })
    // Move cursor on elements
    // const ducaleCursor = $('.ducale-cursor');
    $('.hover-ducale-cursor').mousemove(() => {
        if (window.innerWidth >= 1400) {
            let translateMod = {
                transform: "translate( calc(" + mouseX + "px - 50%), calc(" + mouseY + "px - 50%) )"
            };
            ducaleCursor.css(translateMod);
        }
    }).mouseover((e) => {
        if (window.innerWidth >= 1400) {
            if ($(e.currentTarget).hasClass('hover-ducale-cursor--white')) {
                ducaleCursor.addClass(['ducale-cursor--visible', 'ducale-cursor--ducale-white']);
            } else {
                ducaleCursor.removeClass('ducale-cursor--ducale-white');
                ducaleCursor.addClass(['ducale-cursor--visible']);
            }
        }
    }).mouseleave((e) => {
        if (window.innerWidth >= 1400) {
            if ($(e.currentTarget).hasClass('hover-ducale-cursor--white')) {
                ducaleCursor.removeClass('ducale-cursor--visible');
            } else {
                ducaleCursor.removeClass(['ducale-cursor--visible']);
            }
        }
    });

    // AOS animations
    $(function() {
        AOS.init({
            duration: 600,
            once: true,
        });
    });

    // before after effect
    $("#slider").on("input change", (e)=>{
        const sliderPos = e.target.value;
        // Update the width of the foreground image
        $('.foreground-img').css('width', `${sliderPos}%`)
        // $('.background-img').css('width', `${sliderPos}%`)
        // Update the position of the slider button
        $('.slider-button').css('left', `calc(${sliderPos}% - 30px)`)
        $('.slider-bar').css('left', `${sliderPos}%`)
    });

    // work card animation return
    $(".hover-hole").mouseout(function() {
        $(this).addClass("hover-minimize");
    });

    // sub categories swiper in master categories ---------
    let swSubActive = $(".activate-swiper-sub")
    swSubActive.mouseenter(function () {
        $(".sub-categories-swiper").show()
    })

    // swSubActive.mouseleave(function () {
    //     $(".sub-categories-swiper").hide()
    // })

    let subSwiper = new Swiper('.swiper_subcategories', {
        allowTouchMove: false,
        simulateTouch: false,
        direction: 'vertical',
        speed: 400,
        spaceBetween: 30,
    });

    $('.sub-categories-swiper-list span').on('mouseover' , function (e) {
        let attr = ($(this).attr('data-slide'));
        subSwiper.slideTo(attr-1);
    })

    // master categories swiper in home ---------
    let swMasterActive = $(".activate-swiper-master")
    swMasterActive.mouseenter(function () {
        $(".master-categories-swiper").addClass('master-categories-swiper--visible')
    })

    // swMasterActive.mouseleave(function () {
    //     $(".sub-categories-swiper").hide()
    // })

    let masterSwiper = new Swiper('.swiper_mastercategories', {
        allowTouchMove: false,
        simulateTouch: false,
        direction: 'vertical',
        speed: 400,
        spaceBetween: 30,
    });

    $('.master-categories-swiper-list span').on('mouseover' , function (e) {
        let attr = ($(this).attr('data-slide'));
        masterSwiper.slideTo(attr-1);
    })

    let activeSubimg = $('.activate-sub-img')
    activeSubimg.on('click', function (e) {
        activeSubimg.removeClass('active')
        $(this).addClass('active');
        let imgAttr = ($(this).attr('data-img'));
        let imgObjname = '.sub-img-'+imgAttr;
        $('.sub-img').hide();
        $(imgObjname).show();
        $('.hover-btn').css('display','flex');
    })

});
